//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import avatarUpload from "components/avatarUpload.vue";
export default {
  data: function data() {
    return {
      radio: 0,
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      firstCount: 5000,
      secondCount: 10000,
      thirdCount: 10000,
      fourthCount: 10000,
      examtCount: "",
      enrolmentCount: 0,
      zname: "",
      zphone: "",
      sname: "",
      sphone: "",
      kname: "",
      kphone: "",
      bname: "",
      bphone: "",
      jname: "",
      jphone: "",
      examDate: "",
      handheldModel: "",
      schoolName: ""
    };
  },
  props: {
    examId: {
      type: String,
      default: ""
    }
  },
  components: {},
  created: function created() {
    this.getMeetingEnrollInfo();
  },
  methods: {
    surplusNumber: function surplusNumber() {
      if (this.radio == 1 || this.radio == 2 || this.radio == 3 || this.radio == 4) {
        if (this.enrolmentCount <= 0) {
          this.$message.warning('报考人数超出该时间段剩余人数！');
        }
      }
    },
    //获取报名详情
    getMeetingEnrollInfo: function getMeetingEnrollInfo() {
      var that = this;
      this.$http.post("/api/XOrg/ExamSingUpManager/getMeetingEnrollInfo", {
        id: that.examId
      }).then(function (rst) {
        that.firstCount = rst.countOne;
        that.secondCount = rst.countTow;
        that.thirdCount = rst.countThree;
        that.fourthCount = rst.countFour;
        that.radio = rst.info.SingUpTime;
        that.enrolmentCount = rst.info.StudentNumber;
        that.zname = rst.info.ExamMainName;
        that.zphone = rst.info.ExamMainPhone;
        that.sname = rst.info.ExamPlaceName;
        that.sphone = rst.info.ExamPlacePhone;
        that.kname = rst.info.ExaminationName, that.kphone = rst.info.ExaminationPhone, that.bname = rst.info.SchoolSingUpName;
        that.bphone = rst.info.SchoolSingUpPhone;
        that.jname = rst.info.ExamRoomMangerName;
        that.jphone = rst.info.ExamRoomMangerPhone;
        that.handheldModel = rst.info.PDAType;
        that.schoolName = rst.info.SchoolName;
      });
    },
    getSurplusNumber: function getSurplusNumber() {
      var that = this;
      this.$http.post("/api/XOrg/ExamSingUpManager/getSurplusNumber", {}).then(function (rst) {
        if (rst.code > 0) {
          that.firstCount = rst.countOne;
          that.secondCount = rst.countTow;
          that.thirdCount = rst.countThree;
          that.fourthCount = rst.countFour;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //返回
    goback: function goback() {
      this.$router.go(-1);
    },
    submit: function submit() {
      var that = this;

      if (this.enrolmentCount == 0) {
        this.$message.warning("请输入报考人数");
        return false;
      }

      if (this.radio == '') {
        this.$message.warning("请选择考试时间");
        return false;
      }

      if (this.zname == "") {
        this.$message.warning("请输入总负责人姓名");
        return false;
      }

      if (this.zphone == "") {
        this.$message.warning("请输入总负责人联系方式");
        return false;
      }

      if (this.sname == "") {
        this.$message.warning("请输入实训场地管理员姓名");
        return false;
      }

      if (this.sphone == "") {
        this.$message.warning("请输入实训场地管理员联系方式");
        return false;
      }

      if (this.kname == "") {
        this.$message.warning("请输入考务管理员姓名");
        return false;
      }

      if (this.kphone == "") {
        this.$message.warning("请输入考务管理员联系方式");
        return false;
      }

      if (this.bname == "") {
        this.$message.warning("请输入报名管理员姓名");
        return false;
      }

      if (this.bphone == "") {
        this.$message.warning("请输入报名管理员联系方式");
        return false;
      }

      if (this.jname == "") {
        this.$message.warning("请输入机房管理员姓名");
        return false;
      }

      if (this.jphone == "") {
        this.$message.warning("请输入机房管理员联系方式");
        return false;
      }

      if (this.handheldModel == "") {
        this.$message.warning("请输入手持型号及数量");
        return false;
      }

      this.$http.post("/api/XOrg/ExamSingUpManager/updateInfo", {
        Id: this.examId,
        StudentNumber: this.enrolmentCount,
        SingUpTime: this.radio,
        ExamMainPhone: this.zphone,
        ExamMainName: this.zphone,
        ExamPlacePhone: this.sphone,
        ExamPlaceName: this.sname,
        ExaminationPhone: this.kphone,
        ExaminationName: this.kname,
        SchoolSingUpPhone: this.bphone,
        SchoolSingUpName: this.bname,
        ExamRoomMangerPhone: this.jphone,
        ExamRoomMangerName: this.jname,
        PDAType: this.handheldModel
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
          that.$router.push({
            name: "examDeclare"
          });
        } else {
          that.$message.warning(rst.msg);
          that.getSurplusNumber();
        }
      });
    }
  }
};